<template>
    <div class="content editAddrCompare">
        <p class="location">&nbsp;<span class="spans_2" @click="routerFun">对照管理</span> / <span class="spans_2" @click="routerFun2">产地对照</span> / <span class="spans_1">编辑</span></p>
        <el-form class="form" label-width="140px" :model="form" ref="form" :rules="rules">
            <el-form-item label="节点名称：">
                {{form.name}}
            </el-form-item>
            <el-form-item label="产地编码：" prop="addr_code">
                <el-input v-model="form.addr_code" clearable></el-input>
            </el-form-item>
            <el-form-item label="产地名称：" prop="addr_name">
                <el-input v-model="form.addr_name" clearable></el-input>
            </el-form-item>
            <el-form-item label="自定义编码：" prop="custom_code">
                <el-input v-model="form.custom_code" clearable></el-input>
            </el-form-item>
            <el-form-item label="自定义名称：" prop="custom_name">
                <el-input v-model="form.custom_name" clearable></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 150px">
                <el-button type="primary" class="new-add" @click="submitForm('form')" >保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {UpdateNodeUserdefine} from '../../js/compare/compare.js'
export default {
    name:"editAddrCompare",
    data() {
        return {
            form: {
                code: "", // 节点编码
                name: "", // 节点名称
                addr_code: "", // 产地编码
                addr_name: "", // 产地名称
                custom_code: "", // 自定义编码
                custom_name: "", // 自定义名称
            },
            ghdwArr: [],
            typesArr: [],
            rules: {
                addr_code: [
                    { required: true, message: '请输入产地编码', trigger: 'blur' }
                ],
                addr_name: [
                    { required: true, message: '请输入产地名称', trigger: 'blur' }
                ],
                custom_name: [
                    { required: true, message: '请输入自定义名称', trigger: 'blur' }
                ],
                custom_code: [
                    { required: true, message: '请输入自定义编码', trigger: 'blur' }
                ],
            },
        }
    },
    mounted() {
        let routeMsg2 = ''
        routeMsg2 = this.$route.params
        this.form = {
            name: routeMsg2.node_name, // 节点名称
            code: routeMsg2.node_id, // 节点名称
            addr_name: routeMsg2.before_name, // 节点名称
            addr_code: routeMsg2.before_code, // 节点名称
            custom_name: routeMsg2.userdefine_name, // 自定义名称
            custom_code: routeMsg2.userdefine_code, // 自定义编码
        }
        this.ids = routeMsg2.id
    },
    methods: {
        routerFun(){
            this.$router.push({name: 'CompareList'})
        },
        routerFun2(){
            this.$router.push({name: 'AddrCompare'})
        },
        saveFun(){
            let obj = {
                id: this.ids,
                node_name: this.form.name,
                node_id: this.form.code,
                userdefine_code: this.form.custom_code,
                userdefine_name: this.form.custom_name,
                before_code: this.form.addr_code,
                before_name: this.form.addr_name,
                association_id: '',
                userdefine_type: 4, // 自定义类型1.商户对照2.节点对照3.商品对照4.产地对照
                userdefine_code_one: '',
                userdefine_code_two: '',
                specifications: '',
                janescreen_retrieve: '',
                fullscreen_retrieve: '', // 全拼检索
                managing_mode: '', // 经营模式
                brand: '',
                supplier: '', // 供货来源
                supplier_id: '',
                ws_supplier_id: '', // 供货单位
                ws_supplier: ''
            }
            UpdateNodeUserdefine(obj)
                .then(res => {
                    if (res.result == true) {
                        this.$message.success('保存成功');
                        this.$router.push({name: 'AddrCompare'})
                    }else{
                        this.$message.error(res.message);
                    }
                })
                .catch(res => {
                    console.log(res)
                })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.saveFun()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
    },
}
</script>

<style scoped lang='less'>
    .content{
        width: 100%;
        height: 100%;
        background: #fff;
        .form{
            padding: 50px 0 0 150px;
            .el-input, .el-select{
                width: 400px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/compare/editAddrCompare.vue